import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-4 container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 0,
  class: "dataTable-bottom"
}
const _hoisted_6 = { class: "dataTable-info" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "dataTable-pagination" }
const _hoisted_9 = { class: "dataTable-pagination-list" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "‹", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { href: "#" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "›", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_formulario_unidade = _resolveComponent("formulario-unidade")!
  const _component_unidade_table = _resolveComponent("unidade-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.unidades.id != '-')
          ? (_openBlock(), _createBlock(_component_formulario_unidade, {
              key: 0,
              data: _ctx.unidades,
              operacoes: _ctx.operacoes,
              salvarEmLote: _ctx.salvarEmLote,
              salvarUnico: _ctx.salvarUnico,
              fecharUnico: _ctx.fecharUnico
            }, null, 8, ["data", "operacoes", "salvarEmLote", "salvarUnico", "fecharUnico"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_unidade_table, {
          rows: _ctx.rows,
          salvarUnico: _ctx.salvarUnico,
          getUnico: _ctx.getUnico,
          deleteUnico: _ctx.deleteUnico,
          searchCall: _ctx.searchCall
        }, null, 8, ["rows", "salvarUnico", "getUnico", "deleteUnico", "searchCall"]),
        (!_ctx.pesquisando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(" Mostrando " + _toDisplayString(_ctx.current_page * _ctx.per_page + 1) + " até ", 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.per_page) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPaginas(0)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.per_page_options, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option,
                      value: option
                    }, _toDisplayString(option === -1 ? 'Todos' : option), 9, _hoisted_7))
                  }), 128))
                ], 544), [
                  [
                    _vModelSelect,
                    _ctx.per_page,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createTextVNode(" de " + _toDisplayString(_ctx.total_count) + " " + _toDisplayString(_ctx.local_page), 1)
              ]),
              _createElementVNode("nav", _hoisted_8, [
                _createElementVNode("ul", _hoisted_9, [
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getPaginas(Math.max((_ctx.current_page - 1) * _ctx.per_page, 0)))),
                    class: _normalizeClass(["pager", { disabled: _ctx.current_page === 0 }])
                  }, _hoisted_11, 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.total_pages, (page) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: page,
                      onClick: ($event: any) => (_ctx.getPaginas((page - 1) * _ctx.per_page)),
                      class: _normalizeClass({ active: _ctx.current_page === (page - 1) })
                    }, [
                      _createElementVNode("a", _hoisted_13, _toDisplayString(page), 1)
                    ], 10, _hoisted_12))
                  }), 128)),
                  _createElementVNode("li", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getPaginas(Math.min((_ctx.current_page + 1) * _ctx.per_page, (_ctx.total_pages - 1) * _ctx.per_page)))),
                    class: _normalizeClass(["pager", { disabled: _ctx.current_page === _ctx.total_pages - 1 }])
                  }, _hoisted_15, 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}